import ConstList from '../ConstList'

/**
 * 休暇申請の種別（番号と呼び名）の、ただ1つの置き場。
 *
 * 入力の選択肢（登録・編集）と、一覧・詳細（本人・管理者）が、同じこの並びを使う。
 * 別々に持っていたとき、同じ種別（4）が、選択肢では「欠勤」、一覧と詳細では
 * 「その他欠勤」と出ていた（定数も2つあった）。その前は、詳細の対応にだけ4つ目が無く、
 * 種別の欄に番号（4）がそのまま出ていた。
 * 呼び名は 2026-10-09 に「欠勤」にそろえた（自分の申請一覧・承認待ちの申請の書類名とも同じ）。
 *
 * 並びの順は、選択肢に出す順。
 */
const TYPES = Object.freeze([
  Object.freeze({ id: ConstList.PAID_ID, name: ConstList.PAID_NAME }),
  Object.freeze({ id: ConstList.SUBSTITUTE_ID, name: ConstList.SUBSTITUTE_NAME }),
  Object.freeze({ id: ConstList.SPECIAL_ID, name: ConstList.SPECIAL }),
  /*
   * **欠勤は休暇ではないが、申請の種別としては持つ。**
   * 勤務表で欠勤を選べるのに申請が無いと、誰の承認も要らずに勤務表へ書けてしまう。
   */
  Object.freeze({ id: ConstList.ABSENCE_ID, name: ConstList.ABSENCE })
])

/** 入力の「種別」の選択肢。画面ごとに書き換えられてもよいよう、写しを返す。 */
export function leaveTypeOptions () {
  return TYPES.map(type => ({ id: type.id, name: type.name }))
}

/** 知らない番号・空は、空の字で返す（番号を画面に出さない）。 */
export function leaveTypeName (type) {
  if (type === null || type === undefined || type === '') return ''
  const found = TYPES.find(one => one.id === Number(type))
  return found === undefined ? '' : found.name
}
